import React, { useEffect, useRef, useState } from "react";
import { ArrowUpRight } from "lucide-react";

import Slider from "react-slick";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import HomeService from "../../../Services/HomeService";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

export function WinnersBannerBlue() {
  const containerRef = useRef(null);
  const navigate = useNavigate()
  const [banners, setBanners] = useState([]);
  const [loading, setLoading] = useState(false);
  const [activeSlide, setActiveSlide] = useState(0);

  const fetchBanners = async () => {
    try {
      setLoading(true);
      const res = await HomeService.getBanner();
      console.log("Banner", res);
      if (res?.status) {
        setBanners(res?.data);
      } else {
        toast.error(res?.message);
      }
    } catch (error) {
      console.log(error);
      toast.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBanners();
  }, []);

  const settings = {
    dots: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 4000,
    speed: 1000,
    fade: true,
    arrows: false,
    pauseOnHover: false,
    beforeChange: (_, next) => {
      setActiveSlide(next);
    },
  };

  return (
    <section
      className="ws-hero-slider_blue"
      style={{
        height: "80vh",
        position: "relative",
        overflow: "hidden",
      }}
    >
      {loading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "80vh",
            background: "#0c1666",
          }}
        >
          <div
            className="spinner-border text-light"
            role="status"
          >
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      ) : (
        <Slider {...settings}>
          {banners.map((slide, index) => (
            <div key={index}>
              <section className="ws-hero_blue">
                <div className="ws-hero-bg_blue">
                  <img
                    src={slide.image}
                    alt={slide.title}
                    style={{
                      width: "100%",
                      height: "80vh",
                      objectFit: "cover",
                    }}
                  />
                </div>

                <div className="ws-hero-overlay_blue" />
                <div className="ws-hero-glow-a_blue" />
                <div className="ws-hero-glow-b_blue" />

                <div className="ws-hero-content_blue">
                  <span className="ws-hero-tag_blue">
                    Featured · India's premier property platform
                  </span>

                  <h1 className="ws-hero-title_blue">
                    {slide.title}
                  </h1>

                  <p className="ws-hero-desc_blue">
                    {slide.description}
                  </p>

                  <div className="ws-hero-btns_blue">
                    <button className="ws-btn-primary_blue" onClick={() => { navigate("/propertylist") }}>
                      Browse Properties
                      <ArrowUpRight size={18} />
                    </button>
                  </div>
                </div>
              </section>
            </div>
          ))}
        </Slider>
      )}

      {/* Progress Dots */}
      <div className="bannerdot_blue">
        {banners.map((_, index) => (
          <div
            key={index}
            style={{
              width: activeSlide === index ? "16px" : "10px",
              height: activeSlide === index ? "16px" : "10px",
              borderRadius: "50%",
              background: "#fff",
              marginBottom: "12px",
              transition: "all .4s ease",
              opacity: activeSlide === index ? 1 : 0.4,
            }}
          />
        ))}
      </div>
    </section>
  );
}